export default __webpack_public_path__ + "static/maesh-748e8a5c98a8e25e3b6f1c98ab76334e.webp";